module.exports = {
  title: 'Telegram Switch Theme with Skia and Reanimated 🌙',
  author: 'Enzo Manuel Mangano',
  date: '2023-09-12',
  slug: 'telegram-theme-switch',
  tags: ['reanimated', 'skia', 'gesture-handler'],
};
